import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatTabGroup } from '@angular/material';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { MainService } from 'src/app/_services/main.service';
import { AppState } from 'src/app/app.state';
import { Store } from '@ngrx/store';
import { ResultboardService } from 'src/app/resultboard/resultboard.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-mobile-infobox',
  templateUrl: './mobile-infobox.component.html',
  styleUrls: ['./mobile-infobox.component.scss']
})

export class MobileInfoboxComponent implements OnInit {
  @Input() selectedIndex: number | null;
  parameters = {player_id:'',season_id:'',league_id:'',league_team_id:0,abbr:'false',draft_status:'pending'};
  sub_PlayerData: Subscription;
  sub_draft_turn: Subscription;
  subpickerTime: Subscription;
  sub_init_data: Subscription;
  subDraftButton: Subscription;
  sub_current_pick_number: Subscription;
  sub_players_list: Subscription;
  sub_league_draft: Subscription;
  sub_game_position_filers: Subscription;
  subdraftActiveEmit: Subscription;
  subdraftActiveOn: Subscription;
  sub_isMobileScreen: Subscription;
  sub_positionsRemoved: Subscription; 
  currentUser: any;
  loginUserID: number;
  summaryInfo: any;
  assetUploadURL: string;
  noOfRecord = 0;
  picker_id = 0;
  playerDetail: any;
  p_loc: string;
  is_draft_enable = false;
  activeTab = 0;
  newsInfo: any = [];
  gameLogInfo: any = [];
  careerStatsInfo: any = [];
  prePlayer = 0;
  nextPlayer = 0;
  userDraftTurn = 0;
  current_pick_number = 0;
  draftSelectBox: any;
  selected: string;
  isMobile = true;
  storePlayerList:any;
  rosterPositionData:any;
  leagueRecord:any; 
  showDraftBox = false;
  positionRemoved: any = [];

  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

  constructor(private _mainService: MainService,
    private spinner: NgxSpinnerService,private route: ActivatedRoute) { 
      
    this.route.params.subscribe(params => { 
      this.parameters.player_id = params.player_id;
      this.parameters.season_id = params.season_id;
      this.parameters.league_id = params.league_id;
    });
  }

  ngOnInit() { 
    this.assetUploadURL = `${environment.assetUploadURL}`;
    this.getPlayerInfo('summary');    
  }

  changeTab(val) {
    this.tabGroup.selectedIndex = val;
  }

  changeTabData(val) {
    if (val === 1) {
      if (this.gameLogInfo.length === 0) {
        this.getPlayerInfo('game_log');
      }
    } else if (val === 2) {
      if (this.careerStatsInfo.length === 0) {
        this.getPlayerInfo('career_stats');
      }
    } else if (val === 3) {
      if (this.newsInfo.length === 0) {
        this.getPlayerInfo('news');
      }
    }
  }

  getPlayerInfo(tab_name) { 
    if (this.parameters.player_id && this.parameters.season_id && this.parameters.league_id /* && this.parameters.league_team_id  */&& this.parameters.abbr) {
      this.sub_PlayerData = this._mainService.getPlayerInfoData(this.parameters.player_id, this.parameters.season_id, this.parameters.league_id,
        this.parameters.league_team_id, this.parameters.abbr, this.parameters.draft_status, tab_name).subscribe(res => {  
          if (res.status === 'success') {
            if (tab_name === 'summary') {
              if (res.entities) {
                this.playerDetail = res.entities.playerDetail;
                this.summaryInfo = res.entities;
                if (res.entities.nextGameData && res.entities.nextGameData.player_location === 'home') {
                  this.p_loc = 'vs';
                } else {
                  this.p_loc = '@';
                }  
              }
            } else if (tab_name === 'news') {
              this.newsInfo = res.entities.news;
            } else if (tab_name === 'game_log') {
              this.gameLogInfo = res.entities;
            } else if (tab_name === 'career_stats') {
              this.careerStatsInfo = res.entities;
            }
          }
          this.spinner.hide();   
        })
    }
  } 

  ngOnDestroy() {
    if (this.sub_PlayerData) { this.sub_PlayerData.unsubscribe(); }
    if (this.sub_draft_turn) { this.sub_draft_turn.unsubscribe(); }
    if (this.sub_init_data) { this.sub_init_data.unsubscribe(); }
    if (this.subpickerTime) { this.subpickerTime.unsubscribe(); }
    if (this.subDraftButton) { this.subDraftButton.unsubscribe(); }
    if (this.sub_current_pick_number) { this.sub_current_pick_number.unsubscribe(); }
    if (this.sub_players_list) { this.sub_players_list.unsubscribe(); }
    if (this.sub_league_draft) { this.sub_league_draft.unsubscribe(); }
    if(this.sub_game_position_filers) { this.sub_game_position_filers.unsubscribe();} 
    if(this.subdraftActiveEmit) { this.subdraftActiveEmit.unsubscribe();} 
    if(this.subdraftActiveOn) { this.subdraftActiveOn.unsubscribe();} 
    if(this.sub_positionsRemoved) { this.sub_positionsRemoved.unsubscribe(); }
  } 

}
